import axios from 'axios';

export default {
    list(search = null) {
        let param = '';

        if(search){
            param = '?search=' + search;
        }
        return axios.get(process.env.VUE_APP_API_URI + '/api/parametrages' + param);
    },
}
